module.exports = __webpack_public_path__ + "fe35c3d6a6b7d804bc2b0c1bb2cd325a.svg";